import { HugeiconsIcon } from "@hugeicons/react";
import { Briefcase01Icon, CheckListIcon, Globe02Icon, HandshakeIcon, Layers01Icon, Megaphone01Icon, Settings01Icon, ShoppingCart01Icon, Store01Icon, Target01Icon, TrendingUpIcon } from "@hugeicons-pro/core-bulk-rounded";
import type { IconSvgElement } from "@hugeicons/react";

import { Link, useLocation, useNavigate } from "react-router";

import { logout } from "@/lib/api/auth";
import { SimpleSidebar, type RailNavItem } from "@/components/layout/simple-sidebar";

interface NavItem {
  title: string;
  href: string;
  icon: IconSvgElement;
  matchPrefix?: boolean;
}

interface NavGroup {
  label: string;
  items: NavItem[];
}

// Bronnen (/sources) is intentionally not in the nav for now — the page still
// exists and opens directly at /data/sources.
const NAV: NavGroup[] = [
  {
    label: "Overzicht",
    items: [
      { title: "Overzicht", href: "/", icon: TrendingUpIcon },
      { title: "Markten", href: "/markten", icon: Globe02Icon, matchPrefix: true },
      { title: "Benchmarks", href: "/benchmarks", icon: Target01Icon, matchPrefix: true },
    ],
  },
  {
    label: "E-commerce",
    items: [
      { title: "E-commerce", href: "/ecom", icon: ShoppingCart01Icon, matchPrefix: true },
      { title: "Merken", href: "/brands", icon: Store01Icon, matchPrefix: true },
      { title: "Platformen", href: "/platforms", icon: Layers01Icon, matchPrefix: true },
      { title: "Campagnes", href: "/campagnes", icon: CheckListIcon, matchPrefix: true },
    ],
  },
  {
    label: "Merk & talent",
    items: [
      { title: "Awareness", href: "/awareness", icon: Megaphone01Icon, matchPrefix: true },
      { title: "Job ads", href: "/jobs", icon: Briefcase01Icon, matchPrefix: true },
      { title: "Collaboraties", href: "/collaborations", icon: HandshakeIcon, matchPrefix: true },
    ],
  },

];

export function AppSidebar({
  collapsed = false,
  onNavigate,
  className,
}: {
  collapsed?: boolean;
  onNavigate?: () => void;
  className?: string;
}) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  function isActive(item: NavItem): boolean {
    if (item.href === "/") return pathname === "/";
    return item.matchPrefix ? pathname.startsWith(item.href) : pathname === item.href;
  }

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  const toRail = (item: NavItem): RailNavItem => ({
    title: item.title,
    href: item.href,
    icon: item.icon,
    active: isActive(item),
  });

  return (
    <SimpleSidebar
      sections={NAV.map((group) => ({
        label: group.label,
        items: group.items.map(toRail),
      }))}
      footerItems={[
        {
          title: "Instellingen",
          href: "/settings",
          icon: Settings01Icon,
          active: pathname === "/settings",
        },
      ]}
      collapsed={collapsed}
      roleLabel="Pulse"
      onLogout={handleLogout}
      onNavigate={onNavigate}
      className={className}
    />
  );
}
